



























































































import {
  defineComponent,
  PropType,
  ref,
  computed,
  ComputedRef,
} from '@vue/composition-api';
import {
  EpigraphicWord,
  EpigraphicUnitSide,
  RowTypes,
  RowContent,
  AddWordEditPayload,
  EditorDiscourseWord,
  SearchSpellingResultRow,
} from '@oare/types';
import sl from '@/serviceLocator';
import { TabletRenderer } from '@oare/oare';
import Row from '@/views/Texts/CollectionTexts/AddTexts/Editor/components/Row.vue';
import { RowWithLine } from '@/views/Texts/CollectionTexts/AddTexts/Editor/components/Column.vue';
import { v4 } from 'uuid';
import GrammarDisplay from '@/views/DictionaryWord/components/WordInfo/components/Forms/components/GrammarDisplay.vue';
import ConnectDiscourseItem from '../../../CollectionTexts/AddTexts/Discourse/components/ConnectDiscourseItem.vue';

export default defineComponent({
  props: {
    value: {
      type: Boolean,
      required: true,
    },
    previousWord: {
      type: Object as PropType<EpigraphicWord>,
      required: false,
    },
    textUuid: {
      type: String,
      required: true,
    },
    renderer: {
      type: Object as PropType<TabletRenderer>,
      required: true,
    },
    column: {
      type: Number,
      required: true,
    },
    side: {
      type: String as PropType<EpigraphicUnitSide>,
      required: true,
    },
    line: {
      type: Number,
      required: true,
    },
  },
  components: {
    Row,
    GrammarDisplay,
    ConnectDiscourseItem,
  },
  setup(props, { emit }) {
    const server = sl.get('serverProxy');
    const actions = sl.get('globalActions');

    const row = ref<RowWithLine>({
      type: 'Line' as RowTypes,
      uuid: v4(),
      isEditing: false,
      hasErrors: false,
      text: '',
      line: 0,
    });

    const addWordLoading = ref(false);

    const addWord = async () => {
      try {
        addWordLoading.value = true;
        if (!row.value) {
          throw new Error('No row data');
        }

        if (row.value.words?.length !== 1) {
          throw new Error('More than one word entered for addition');
        }

        const rowContent: RowContent = {
          uuid: row.value.uuid,
          type: 'Line',
          lines: [],
          value: 1,
          text: row.value.text,
          signs: row.value.signs,
          words: row.value.words,
          reading: row.value.reading,
          hasErrors: row.value.hasErrors,
        };

        const payload: AddWordEditPayload = {
          type: 'addWord',
          textUuid: props.textUuid,
          side: props.side,
          column: props.column,
          line: props.line,
          row: rowContent,
          previousWord: props.previousWord,
          spellingUuid: form.value ? form.value.spellingUuid : null,
          transcription: form.value ? form.value.form.form : null,
        };
        await server.editText(payload);
        emit('reset-renderer');
      } catch (err) {
        actions.showErrorSnackbar(
          'Error adding word. Please try again.',
          err as Error
        );
      } finally {
        addWordLoading.value = false;
        emit('reset-current-edit-action');
        emit('input', false);
      }
    };

    const stepOneComplete = computed(() => {
      return (
        row.value &&
        row.value.signs &&
        row.value.signs.length > 0 &&
        row.value.signs.every(sign => sign.type) &&
        !row.value.hasErrors
      );
    });

    const step = ref(1);

    const form = ref<SearchSpellingResultRow>();

    const editorDiscourseWord: ComputedRef<EditorDiscourseWord | undefined> =
      computed(() => {
        if (row.value && row.value.words) {
          return {
            ...row.value.words[0],
            type:
              row.value.signs &&
              row.value.signs.every(sign => sign.readingType === 'number')
                ? 'number'
                : 'word',
          };
        } else {
          return undefined;
        }
      });

    const goBack = () => {
      step.value = 1;
      form.value = undefined;
    };

    const formsLoaded = ref(false);

    return {
      row,
      addWordLoading,
      addWord,
      stepOneComplete,
      step,
      form,
      editorDiscourseWord,
      goBack,
      formsLoaded,
    };
  },
});
